module.exports = __webpack_public_path__ + "img/4.6ed94707.jpg";